module.exports = __webpack_public_path__ + "img/default_group.c85f85aa.png";